import { TinkLinkUrlParameter } from '@tink/config/src/TinkLinkUrlParameter';
import { OmitStrict } from '@tink/core/src/types';
import { RefreshableItem } from '../models/refreshableItem';
import { CommonError } from '../stores/app-state-errors';
import { AppParameters } from './application-parameters';
import { ERR_INVALID_PARAMETER_EXTERNAL_REFERENCE } from './error';

export type ValidatedCommonUrlParameters = {
  errors: CommonError[];
  parameters: OmitStrict<AppParameters, 'refreshableItems'>;
};

export type ValidatedUrlParameters = {
  errors: CommonError[];
  parameters: AppParameters;
};

export type SomeValidatedCommonUrlParameters = {
  errors: CommonError[];
  parameters: Partial<OmitStrict<AppParameters, 'refreshableItems'>> & {
    refreshableItems: RefreshableItem[];
  };
};

export type GetRawParam = (key: TinkLinkUrlParameter) => string | undefined;

export type ValidateProductParams = (
  commonParams: ValidatedCommonUrlParameters['parameters'],
  getRawParam: GetRawParam
) => SomeValidatedCommonUrlParameters;

export const isEnumType =
  <T>(filter: Record<string, T>) =>
  (value: unknown): value is T => {
    return Object.values(filter).includes(value as T);
  };

/**
 * Function to be used by urlParams for products the makes use of `external_reference`.
 */
export const validateExternalReference = (externalReference: string) => {
  const GENERIC_UUID_LIKE = /^[a-zA-Z0-9-]{1,50}$/gi;

  if (GENERIC_UUID_LIKE.test(externalReference) || externalReference.length === 0) {
    return undefined;
  }

  return ERR_INVALID_PARAMETER_EXTERNAL_REFERENCE;
};
